import styled from 'styled-components';

const typeColors = {
  andamento: 'working',
  entrega: 'delivery',
  agendamento: 'schedule',
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  background-color: ${({ theme, type }) =>
    theme.colors[typeColors[type]] || theme.colors.pending};
  transition: transform 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px 0;
`;

export const OrderCode = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.2px;
`;

export const TimerBadge = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.85);
`;

export const BodyCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  gap: 6px;
`;

export const InfoRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const CustomerName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60%;
`;

export const TotalValue = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
`;

export const TagsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  color: ${({ highlight }) => highlight ? 'rgba(0, 0, 0, 0.75)' : 'rgba(255, 255, 255, 0.9)'};
  background-color: ${({ highlight }) => highlight ? 'rgba(255, 255, 255, 0.9)' : 'rgba(255, 255, 255, 0.15)'};
  letter-spacing: 0.2px;
  white-space: nowrap;
`;

export const Separator = styled.div`
  height: 1px;
  background-color: rgba(255, 255, 255, 0.12);
  margin: 0 12px;
`;

export const FooterCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 6px 6px 12px;
`;

export const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const ActionBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
    color: #fff;
  }
`;

export const NextStatusBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 30px;
  padding: 0 12px;
  border: none;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.2);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.35);
  }
`;

/* ---- Expand section ---- */

export const ExpandSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 12px 8px;
  gap: 2px;
`;

export const ExpandLabel = styled.span`
  font-size: 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.75);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 6px;
  margin-bottom: 2px;
`;

export const ProductRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 0;
`;

export const ProductName = styled.span`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
`;

export const ProductQty = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.6);
  margin-right: 6px;
  min-width: 20px;
`;

export const ProductPrice = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
`;

export const ContactLine = styled.span`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
`;

export const StatusPaymentOnline = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  background-color: #22c913e5;
  border: 1px solid rgba(255, 255, 255, 0.25);
`;

export const StatusLoyaltyBenefit = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  background-color: #8f5ff0e5;
  border: 1px solid rgba(255, 255, 255, 0.25);
`;

export const ContainerIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #575757;
  margin-right: 8px;
  padding: 8px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
`;
